import { memo } from 'react';
import PropTypes from 'prop-types';
import H7 from '@base/H7/H7';
import styled from '@emotion/styled';
import ChevronDown from '@icon/ChevronDown';
import { Spacings } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';

const Wrapper = styled.div`
  position: absolute;
  z-index: 2;
  left: 25%;
  top: ${Spacings.SPACING_20B};
  transform: translate3d(
    0,
    ${({ $show }) => ($show ? '0' : `-${Spacings.SPACING_27B}`)},
    0
  );
  margin: auto;
  background: var(--color-base-fill);
  width: 69px;
  max-width: 50%;
  border-radius: ${Spacings.SPACING_6B};
  padding: ${Spacings.SPACING_1B} ${Spacings.SPACING_2B};
  padding-left: ${Spacings.SPACING_6};
  display: flex;
  cursor: pointer;
  transition: all 200ms ease-in-out;
  &:hover {
    background: var(--color-primary-focus);
    box-shadow: ${boxShadowGenerator({
      yOffset: Spacings.SPACING_2B,
      blur: Spacings.SPACING_4B
    })};
  }
`;

const StyledArrowDown = styled(ChevronDown)`
  transform: ${({ $direction }) =>
    $direction === 'right' ? 'rotate(-90deg)' : 'rotate(90deg)'};
`;

const Title = styled(H7)`
  margin-left: ${({ $direction }) =>
    $direction === 'right' ? `${Spacings.SPACING_1B}` : '0px'};

  line-height: 133%;
`;

const TodayPill = memo(({ show, todayDirection, goToToday }) => {
  const onClick = () => {
    goToToday();
  };
  return (
    <Wrapper onClick={onClick} $show={show}>
      {todayDirection === 'left' ? (
        <StyledArrowDown
          size="16px"
          color="var(--color-base-1)"
          $direction={todayDirection}
        />
      ) : null}
      <Title color="var(--color-base-1)" $direction={todayDirection}>
        Today
      </Title>
      {todayDirection === 'right' ? (
        <StyledArrowDown
          size="16px"
          color="var(--color-base-1)"
          $direction={todayDirection}
        />
      ) : null}
    </Wrapper>
  );
});

TodayPill.displayName = 'TodayPill';

TodayPill.propTypes = {
  listRef: PropTypes.shape({}).isRequired,
  show: PropTypes.bool.isRequired,
  todayDirection: PropTypes.oneOf(['up', 'down', ''])
};

TodayPill.defaultProps = {
  todayDirection: 'up'
};

export default TodayPill;
